import interactionPlugin from '@fullcalendar/interaction';
import listPlugin from '@fullcalendar/list';
import FullCalendar from '@fullcalendar/react';
import timeGridPlugin from '@fullcalendar/timegrid';
import { Box, useMediaQuery } from '@mui/material';
import { BreadcrumbsCC } from 'components/Layout';
import NoEventCC from 'components/Layout/NoEventCC';
import { PATH_ROOT } from 'constants/api';
import { CALENDAR_VIEW, SLICE_NAME, STATUS_MEETING_EVENT } from 'constants/common';
import { FUNCTIONS } from 'constants/roles';
import dayjs from 'dayjs';
import moment from 'moment';
import 'moment/locale/vi';
import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { checkFunctionHaveCode } from 'store/user/functions';
import { selectCurrentUserFunctions } from 'store/selectors';
import { renderEvent, renderEventList, renderHeader, setIsTodayInCurrentView } from '../Func';
import '../ManagerMeetings.css';
import SearchMeetings from '../SearchMeetings';
import DialogLimitTotalMeeting from './DialogLimitTotalMeeting';
import DialogLimitTotalMeetingHost from './DialogLimitTotalMeetingHost';
import './index.css';
import { fetchDataManagerMeeting, updateCalenderView, updateCurrentDay, updateQuery } from '../managerMeetingSlice';
import BreadcrumbsMeeting from './BreadcrumbsMeeting';
import useManagerMeeting from '../hook/useManagerMeeting';

const CalendarMeetings = () => {
    const { t, i18n } = useTranslation()
    const functions = useSelector(selectCurrentUserFunctions);
    moment.locale(i18n.language)
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const { events, query, view: calenderView } = useSelector(state => state[SLICE_NAME.MANAGER_MEETING])
    const isMobile = useMediaQuery('(max-width:600px)');
    const calendarRef = useRef(null)
    const [todayInView, setTodayInView] = useState(false)
    const { currentDay } = useSelector(state => state[SLICE_NAME.MANAGER_MEETING])
    const { refreshGlobal } = useSelector(state => state[SLICE_NAME.COMMON])
    const { handleChangeTimeInCalendar, getEndTime, getStartTime } = useManagerMeeting()
    const [view, setView] = useState(calenderView || CALENDAR_VIEW.TIME_GRID_WEEK)
    const [diffTime, setDiffTime] = useState({ type: view, current: dayjs(), diff: 0 })

    // const [contentHeightSchedule, setContentHeightSchedule] = useState(() => {
    //     // Nếu set initialview dạng list thì true ngược lại false
    //     return getContentHeight(true)
    // })

    const totalMeeting = () => {
        return checkFunctionHaveCode(functions, FUNCTIONS.MANAGE_LIMIT_CONCURRENT_MEETING)
    }

    const handleOpenDetailRoom = (id, parentRoomId, startRoom = false, status) => {
        const canceledEndedExpriedArray = [STATUS_MEETING_EVENT.CANCELED, STATUS_MEETING_EVENT.ENDED, STATUS_MEETING_EVENT.EXPIRED]
        if (canceledEndedExpriedArray.includes(status)) {
            // dispatch(setStartTimeRoom(startRoom));
            localStorage.setItem("StartTimeRoom", startRoom);
        } else {
            // dispatch(setStartTimeRoom(null));
            localStorage.setItem("StartTimeRoom", null);
        }
        navigate(`${PATH_ROOT}/manager-meeting/details/${id || parentRoomId}`)
    }

    useEffect(() => {
        fetchDataManagerMeeting(query)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [query.end, query.page, query.roomName, query.start, query.statusDisplay, query.type, query.typeMeeting, refreshGlobal])

    useEffect(() => {
        if (isMobile) {
            handleChangeView(CALENDAR_VIEW.TIME_GRID_DAY)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isMobile])


    // useEffect(() => {
    //     setTimeout(() => {
    //         // Ẩn text giờ
    //         const elms = document.getElementsByClassName('fc-timegrid-slot-label-cushion')

    //         if(elms?.length) {
    //             for (let i = 0; i < elms.length; i++) {
    //                 if(elms[i].innerText.length > 2) elms[i].innerText = elms[i].textContent.slice(0,2)
    //             }
    //         } 
    //     }, 750);

    //     if (!contentHeightSchedule) {
    //         setTimeout(() => {
    //             setContentHeightSchedule((prev) => getContentHeight(true))
    //         }, 100)
    //     }

    //     window.addEventListener('resize', handleWindowSizeChange);
    //     return () => {
    //         window.removeEventListener('resize', handleWindowSizeChange);
    //     };
    // }, [])

    useEffect(() => {
        calendarRef.current.getApi().today()
        switch (calendarRef.current.getApi().view.type) {
            case CALENDAR_VIEW.TIME_GRID_DAY:
                calendarRef.current.getApi().incrementDate({ days: diffTime?.diff })
                break
            default:
                calendarRef.current.getApi().incrementDate({ weeks: diffTime?.diff })
                break;
        }
    }, [diffTime])


    /**
     * Chuyển dạng Calendar
     * @param {*} typeView 
     */
    const handleChangeView = (typeView) => { // Chuyển dạng view tùy thuộc vào nhuộc tính đầu vào
        // setContentHeightSchedule(prevState => getContentHeight(typeView.includes('list'))) // Set chiều cao cho calendar
        calendarRef.current.getApi().changeView(typeView)   // Thay đổi dạng calendar
        setView(typeView)   // Cập nhật state
        dispatch(updateCalenderView(typeView))
        // dispatch(updateCurrentDay(dayjs())) // Cập nhật ngày hiện tại ở store
        // dispatch(updateQuery({
        //     type: 'not_start-progress',
        //     start: moment(DEFAULT_TIMESEARCH.startDate).unix() * 1000,
        //     end: moment(DEFAULT_TIMESEARCH.endDate).unix() * 1000,
        //     page: 1,
        //     typeMeeting: '',
        //     roomName: '',
        //     statusDisplay: ''
        // }))
        // setDiffTime((prev) => {     // Cập nhật dạng calendar cho difftime
        //     return { type: typeView, current: dayjs(), diff: 0 }
        // })

    }

    /**
     * Chuyển về ngày hiện tại
     */
    const handleChangeToday = () => {
        dispatch(updateCurrentDay(dayjs())) // Cập nhật ngày hiện tại ở store
        calendarRef.current.getApi().today()    // Cập nhật ngày hiện tại ở calendar
        const type = calendarRef.current.getApi().view.type // Lấy kiểu calendar
        handleChangeTimeInCalendar(type, '', getStartTime(type, dayjs()), getEndTime(type, dayjs()))    // Cập nhật thời gian cho calendar -> call api fetch data
    }

    /**
     * Cập nhật thông tin khi người dùng click button next, prev calendar
     * @param {*} type 
     */
    const handleNextCalendar = (type) => {
        const calenderType = calendarRef.current.getApi().view.type
        let newCurrentDay
        switch (calenderType) {
            case CALENDAR_VIEW.TIME_GRID_DAY:   // Calendar dạng ngày
                if (type === 'next') { // Click next
                    calendarRef.current.getApi().next() // Cập nhật Calender
                    newCurrentDay = dayjs(currentDay).add(1, 'day')
                } else {
                    calendarRef.current.getApi().prev()
                    newCurrentDay = dayjs(currentDay).subtract(1, 'day')
                }
                break
            default:
                calendarRef.current.getApi().incrementDate({ weeks: type === 'next' ? 1 : -1 })
                type === 'next' ? newCurrentDay = moment(currentDay).add(1, 'week') : newCurrentDay = moment(currentDay).subtract(1, 'week')
                break;
        }

        handleChangeTimeInCalendar(calenderType, '', getStartTime(calenderType, newCurrentDay), getEndTime(calenderType, newCurrentDay)) // Cập nhật thời gian -> call Api
        dispatch(updateCurrentDay(newCurrentDay)) // Cập nhật currentDay ở store
    }

    useEffect(() => {
        setView(calenderView)
        const timeStart = moment.unix(query.start / 1000).diff(moment(), 'days')
        const timeStart1 = moment.unix(query.start / 1000).diff(moment(), 'weeks')

        switch (view) {
            case CALENDAR_VIEW.TIME_GRID_DAY:
                calendarRef.current.getApi().incrementDate({ days: timeStart })
                break
            default:
                calendarRef.current.getApi().incrementDate({ weeks: timeStart1 })
                break;
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        if (calendarRef.current) {
            const elms = document.getElementsByClassName('fc-timegrid-slot')

            if (elms?.length) {
                for (let i = 0; i < elms.length; i++) {
                    const text = elms[i].textContent.slice(0, 2)
                    const node = document.createElement("div");
                    node.classList.add('fc-scrollgrid-shrink-cushion')
                    const textnode = document.createTextNode(text);
                    node.appendChild(textnode);
                    elms[i].appendChild(node);
                }
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [calendarRef.current])

    return (
        <React.Fragment>
            <BreadcrumbsCC>
                <BreadcrumbsMeeting />
            </BreadcrumbsCC>
            <DialogLimitTotalMeeting />
            <DialogLimitTotalMeetingHost />
            <SearchMeetings
                diffTime={diffTime}
                setDiffTime={setDiffTime}
                currentTypeView={view}
                todayInView={todayInView}
                handleChangeToday={handleChangeToday}
                handleChangeView={handleChangeView}
                handleNextCalendar={handleNextCalendar}
                query={query}
                updateQuery={updateQuery}
            />
            <FullCalendar
                ref={calendarRef}
                initialView={view || CALENDAR_VIEW.TIME_GRID_WEEK} // dạng view mặc định
                headerToolbar={false}   // render header toolbar mặc định false
                // contentHeight={contentHeightSchedule}   // set Height của schedule
                plugins={[timeGridPlugin, interactionPlugin, listPlugin]}   // dạng tuần. ngày, danh sách
                allDaySlot={false} // render allday <Boolean>
                locale={i18n.language}   // render header tiếng việt
                dayHeaderContent={(args) => renderHeader(args, moment)}     // render header content
                events={events} // events 
                eventContent={(args) => renderEvent(args, moment, handleOpenDetailRoom, t, dispatch, navigate, totalMeeting)} // render content
                eventDidMount={(args) => renderEventList(args)} // handle didmount render content
                slotEventOverlap={false}    // cho event overlap mặc định false
                eventClick={(args) => {
                    if (!args.view.type.includes('list') || isMobile) {
                        const { roomId, status, parentRoomId, realRoomId, tsStart } = args.event._def.extendedProps;
                        handleOpenDetailRoom(realRoomId || roomId, parentRoomId, tsStart, status);
                    }
                }}  // handle event click
                datesSet={(args) => setIsTodayInCurrentView(args, setTodayInView)}
                noEventsContent={() => (<NoEventCC />)}  // Trang hiển thị không có cuộc họp
                scrollTime={moment().format('HH:mm:ss')} // auto scroll đến thời gian hiện tại
                firstDay={1}  // Chế độ hiển thị ngày bắt đầu 0: Chủ nhật; 1: Thứ hai
            />
            {view === CALENDAR_VIEW.LIST_WEEK && Boolean(events?.length) && <Box component={'div'} id='total-meeting' sx={{ lineHeight: '48px', padding: '0 20px', fontSize: '0.875em', fontWeight: 500 }}>
                {events?.length} {t('textv1.meeting')}</Box>}
        </React.Fragment>
    )
}

export default CalendarMeetings
